import {
  IoLogoTwitter,
  IoLogoLinkedin,
  IoLogoYoutube,
  IoLogoInstagram,
  IoSunnyOutline,
  IoMoon,
  IoLogoGithub,
  IoLogoHtml5,
  IoLogoPython,
  IoLogoJavascript,
  IoLogoCss3,
  IoDocumentTextOutline,
  IoChatbubblesOutline,
  IoRocketOutline,
  IoCheckmark,
} from "react-icons/io5";
import { FaArrowRight, FaArrowDown } from "react-icons/fa";
import { CgArrowRight } from "react-icons/cg";
import { ExternalLinkIcon } from "@chakra-ui/icons";
import { AiOutlineConsoleSql } from "react-icons/ai";
import {
  DiDjango,
  DiReact,
  DiBootstrap,
  DiDocker,
  DiGit,
} from "react-icons/di";
import { SiChakraui, SiMaterialui, SiVisualstudiocode } from "react-icons/si";
import { TiDocumentText } from "react-icons/ti";
import { Latex } from "../assets/icons/Latex";

const ICONS = {
  TWITTER: IoLogoTwitter,
  LINKEDIN: IoLogoLinkedin,
  YOUTUBE: IoLogoYoutube,
  INSTAGRAM: IoLogoInstagram,
  GITHUB: IoLogoGithub,
  SUNNY: IoSunnyOutline,
  MOON: IoMoon,
  RIGHT_ARROW: CgArrowRight,
  EXTERNAL_LINK: ExternalLinkIcon,
  HTML: IoLogoHtml5,
  PYTHON: IoLogoPython,
  JAVASCRIPT: IoLogoJavascript,
  CSS: IoLogoCss3,
  SQL: AiOutlineConsoleSql,
  DJANGO: DiDjango,
  REACT: DiReact,
  BOOTSTRAP: DiBootstrap,
  MATERIAL_UI: SiMaterialui,
  CHAKRA: SiChakraui,
  LATEX: Latex,
  VSCODE: SiVisualstudiocode,
  DOCKER: DiDocker,
  GIT: DiGit,
  RESUME: TiDocumentText,
  DOCUMENT_TEXT: IoDocumentTextOutline,
  CHAT_BUBBLES: IoChatbubblesOutline,
  ROCKET: IoRocketOutline,
  CHECKMARK: IoCheckmark,
  ARROW_RIGHT: FaArrowRight,
  ARROW_DOWN: FaArrowDown,
};

export default ICONS;
